define((require) => {
    "use strict";

    const ButtonWidgetView              = require("shared/ui/experience/widgets/button/ButtonWidgetView");
    const ButtonWidgetModel             = require("shared/ui/experience/widgets/button/ButtonWidgetModel");
    const CompositeWidgetModel          = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetModel");
    const CompositeWidgetView           = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetView");
    const SalesforceCommerceWidgetModel = require("shared/ui/experience/widgets/salesforceCommerceWidget/model/SalesforceCommerceWidgetModel");
    const SalesforceCommerceWidgetView  = require("shared/ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceWidgetView");
    const EmbedWidgetModel              = require("shared/ui/experience/widgets/embedWidget/EmbedWidgetModel");
    const EmbedWidgetView               = require("shared/ui/experience/widgets/embedWidget/EmbedWidgetView");
    const HTMLWidgetView                = require("shared/ui/experience/widgets/htmlWidget/HTMLWidgetView");
    const HTMLWidgetModel               = require("shared/ui/experience/widgets/htmlWidget/HTMLWidgetModel");
    const Enum                          = require("shared/util/Enum");
    const ImageWidgetModel              = require("shared/ui/experience/widgets/imageWidget/ImageWidgetModel");
    const ImageWidgetView               = require("shared/ui/experience/widgets/imageWidget/ImageWidgetView");
    const LineWidgetModel               = require("shared/ui/experience/widgets/lineWidget/LineWidgetModel");
    const LineWidgetView                = require("shared/ui/experience/widgets/lineWidget/LineWidgetView");
    const LinkWidgetModel               = require("shared/ui/experience/widgets/linkWidget/LinkWidgetModel");
    const LinkWidgetView                = require("shared/ui/experience/widgets/linkWidget/LinkWidgetView");
    const ProductWidgetModel            = require("shared/ui/experience/widgets/productWidget/ProductWidgetModel");
    const ProductWidgetView             = require("shared/ui/experience/widgets/productWidget/ProductWidgetView");
    const SceneNavigatorWidgetModel     = require("shared/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetModel");
    const SceneNavigatorWidgetView      = require("shared/ui/experience/widgets/sceneNavigatorWidget/SceneNavigatorWidgetView");
    const ShapeWidgetModel              = require("shared/ui/experience/widgets/shapeWidget/ShapeWidgetModel");
    const ShapeWidgetView               = require("shared/ui/experience/widgets/shapeWidget/ShapeWidgetView");
    const SocialSharingWidgetModel      = require("shared/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetModel");
    const SocialSharingWidgetView       = require("shared/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetView");
    const TextEnhancedWidgetModel       = require("shared/ui/experience/widgets/textEnhancedWidget/TextWidgetModel");
    const TextEnhancedWidgetView        = require("shared/ui/experience/widgets/textEnhancedWidget/TextWidgetView");
    const TextWidgetModel               = require("shared/ui/experience/widgets/textWidget/TextWidgetModel");
    const TextWidgetView                = require("shared/ui/experience/widgets/textWidget/TextWidgetView");
    const YoutubeWidgetModel            = require("shared/ui/experience/widgets/youtubeWidget/YouTubeWidgetModel");
    const YoutubeWidgetView             = require("shared/ui/experience/widgets/youtubeWidget/YouTubeWidgetView");
    const DynamicProductWidgetModel     = require("shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetModel");
    const DynamicProductWidgetView      = require("shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetView");

    /**
     * An enumeration declaring all supported Widget types for the Editor. There is another class filling the same role
     * for the viewer. When adding a new widget to this enum also add it to the ViewerWidgetTypes enum.
     *
     * @class {WidgetTypes}
     */
    return Enum.create("WidgetType", "id", {
        BUTTON: {
            id: "button",
            viewClass: ButtonWidgetView,
            modelClass: ButtonWidgetModel
        },
        COMPOSITE: {
            id: "composite",
            viewClass: CompositeWidgetView,
            modelClass: CompositeWidgetModel
        },
        SALESFORCE_COMMERCE: {
            // Demandware is the old name for Salesforce Commerce Cloud.
            // The Api still returns the 'demandware' object and it would fail if this is refactored to salesforce-commerce.
            // AS long as the DB name is 'demandware' the id has to be same.
            id: "demandware",
            viewClass: SalesforceCommerceWidgetView,
            modelClass: SalesforceCommerceWidgetModel
        },
        EMBED: {
            id: "embed",
            viewClass: EmbedWidgetView,
            modelClass: EmbedWidgetModel
        },
        HTML: {
            id: "html",
            viewClass: HTMLWidgetView,
            modelClass: HTMLWidgetModel
        },
        IMAGE: {
            id: "image",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        LINE: {
            id: "line",
            viewClass: LineWidgetView,
            modelClass: LineWidgetModel
        },
        LINK: {
            id: "link",
            viewClass: LinkWidgetView,
            modelClass: LinkWidgetModel
        },
        NEXT_SCENE: {
            id: "next-scene",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        PREVIOUS_SCENE: {
            id: "previous-scene",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        PRODUCT: {
            id: ProductWidgetModel.TYPE,
            viewClass: ProductWidgetView,
            modelClass: ProductWidgetModel
        },
        SCENE_NAVIGATOR: {
            id: "scene-navigator",
            viewClass: SceneNavigatorWidgetView,
            modelClass: SceneNavigatorWidgetModel
        },
        SHAPE: {
            id: "shape",
            viewClass: ShapeWidgetView,
            modelClass: ShapeWidgetModel
        },
        SOCIAL_SHARING: {
            id: "social-sharing",
            viewClass: SocialSharingWidgetView,
            modelClass: SocialSharingWidgetModel
        },
        TEXT: {
            id: "text",
            viewClass: TextWidgetView,
            modelClass: TextWidgetModel
        },
        // The view and model class for this widget is different then the viewer.
        TEXT_ENHANCED: {
            id: "text-enhanced",
            viewClass: TextEnhancedWidgetView,
            modelClass: TextEnhancedWidgetModel
        },
        YOUTUBE: {
            id: "youtube",
            viewClass: YoutubeWidgetView,
            modelClass: YoutubeWidgetModel
        },
        DYNAMIC_PRODUCT: {
            id: "dynamic-product",
            viewClass: DynamicProductWidgetView,
            modelClass: DynamicProductWidgetModel
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/WidgetTypes.js